(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["enigmae-product-option"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  const option=event.target.closest('#ecp-main-swatches .esk-colour');
  if(!option)return;
  option.parentElement.querySelectorAll('.esk-colour').forEach(button=>button.setAttribute('aria-pressed',String(button.classList.contains('is-active'))));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["enigmae-skincare-story"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const button = event.target.closest('[data-esk-scroll]');
  if (!button) return;
  const track = button.closest('.esk-video-section').querySelector('.esk-video-track');
  track.scrollBy({left: Number(button.dataset.eskScroll) * 252, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});
document.addEventListener('play', event => {
  if (!event.target.matches('.esk-reel')) return;
  document.querySelectorAll('.esk-reel').forEach(video => { if (video !== event.target && video.pause) video.pause(); });
}, true);
  } catch(e) { console.error(e); }
})();

})();
